import type { V2PrivacyControls } from "../../privacy";
import { usePrivateModeRecoveryModal } from "./PrivateModeToggleV2";
import "../../scss/private_mode_access.scss";
import { useTranslation } from "../../i18n";

// Keep the modal subscription mounted when the containing dropdown closes.
export const usePrivateAccountRecovery = (
  controls?: V2PrivacyControls,
  onOpen?: () => void,
  isPrivateMode = false
) => {
  const open = usePrivateModeRecoveryModal(controls);
  const { t } = useTranslation("redacted");
  if (!controls || !isPrivateMode) return null;
  const busy = ["unlocking", "onboarding", "processing"].includes(
    controls.status
  );
  const openRecovery = (view: "import" | "export") => {
    open(view, true);
    onOpen?.();
  };
  return (
    <div
      className="private-account-recovery"
      aria-label={t("privateAccountRecovery")}
      onClick={(event) => event.stopPropagation()}>
      {controls.status === "ready" && controls.activeAccountId && (
        <button
          type="button"
          className="transparent"
          onClick={() => openRecovery("export")}>
          {t("backupPrivateAccount")}
        </button>
      )}
      <button
        type="button"
        className="transparent"
        disabled={busy || controls.recoveryExportRequired}
        onClick={() => openRecovery("import")}>
        {t("restorePrivateAccount")}
      </button>
    </div>
  );
};
